module.exports = __webpack_public_path__ + "static/template_options_month_weekdays_only-90256c290f1ede2e5c3542ef9e257c0a.png";